/**
 * Speech Therapy Re-evaluation Note — options + empty payload.
 * After shared common header (1–6): Re-eval Info → Changes → ST Assessment
 * table (grouped) → Goals → Skilled ST Need (per ST Re-evaluation screenshots).
 */

import { emptyStCommonHeader } from "./stNotesCommonHeaderUtils";
import {
  emptyProgressGoalRow,
  emptyProgressGoals,
} from "../ptNotes/ptGoals";

export const REEVAL_REASON_OPTIONS = [
  "Routine (Per Plan of Care)",
  "Change in Condition",
  "Fall",
  "Post Hospitalization",
  "Post ER Visit",
  "Other",
];

/** Row-major order so a 3-column wrap matches the screenshot columns. */
export const CHANGES_SINCE_LAST_OPTIONS = [
  "New Diagnosis",
  "Hospitalization",
  "ER Visit",
  "Change in Medication",
  "Change in Communication",
  "Change in Swallowing",
  "Change in Functional Status",
  "Change in Cognitive Status",
  "Caregiver Change",
  "Other Significant Change",
];

export const ASSESSMENT_GROUPS = [
  {
    label: "Communication",
    areas: [
      "Expressive Language",
      "Receptive Language",
      "Voice / Fluency",
      "Pragmatics",
    ],
  },
  {
    label: "Cognition",
    areas: ["Attention / Memory", "Problem Solving / Orientation"],
  },
  {
    label: "Swallowing",
    areas: [
      "Swallowing Status (Oral/Pharyngeal)",
      "Diet Consistency",
      "Swallowing Safety / Aspiration Signs",
    ],
  },
];

export const ASSESSMENT_AREA_OPTIONS = ASSESSMENT_GROUPS.flatMap(
  (group) => group.areas,
);

export const FUNCTIONAL_SCALE_AREA = "Functional Scale / Score";

export const CHANGE_OPTIONS = ["Improved", "Declined", "No Change"];

export const GOAL_STATUS_OPTIONS = ["Met", "Partially Met", "Not Met"];

export const YES_NO_OPTIONS = ["Yes", "No"];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

export const today = () => new Date().toISOString().slice(0, 10);

export const emptyAssessmentRow = (area) => ({
  area,
  lastAssessment: "",
  currentAssessment: "",
  change: "",
});

export { emptyProgressGoalRow as emptyGoalRow, emptyProgressGoals as emptyGoals };

export const emptyAssessmentFindings = () =>
  ASSESSMENT_AREA_OPTIONS.map((area) => emptyAssessmentRow(area));

/** Full editable ST Re-evaluation Note payload (JSON on dedicated row). */
export const emptyStReevalNotePayload = () => ({
  billingCode: "G0153",
  timeIn: "",
  timeOut: "",

  visitDate: "",
  commonHeader: emptyStCommonHeader(),

  // —— 7. Re-evaluation Information ——
  reevalReasons: [],
  reevalReasonOther: "",

  // —— 8. Changes Since Last Assessment ——
  changesSinceLast: [],
  changesComments: "",

  // —— 9. Current ST Assessment (grouped, vs last) ——
  assessmentFindings: emptyAssessmentFindings(),
  functionalScaleScore: "",

  // —— 10. Progress Toward Goals ——
  goals: emptyProgressGoals(3),
  additionalGoalsAttached: false,

  // —— 11. Skilled ST Need ——
  skilledStNeed: "",
});

export const ST_REEVAL_ARRAY_KEYS = ["reevalReasons", "changesSinceLast"];
